module.exports = "//static.hsappstatic.net/LoginUI/static-1.8261/img/google-logo.png"